<template>
	<div>
		<CModal title="Ajouter un/des colis à bloquer" size="lg" :show.sync="showModal">
			<form action="/api/cart_products" axiosMethod="patch">
				<FormContent ref="form" v-if="showModal" key="add" />
			</form>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Annuler</CButton>
				<CButton color="success" v-on:click="onSubmit()">Ajouter</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import FormContent from './BlockPackageForm';

	export default {
		components: {
			FormContent,
		},
		data() {
			return {
				showModal: false,
			};
		},

		methods: {
			onSubmit: function () {
				this.$axios
					.post('/api/cart_products/batch-block', {
						ids: this.$refs.form.packages,
					})
					.then(res => {
						if (res.status === 200) {
							this.$toast.success('Blocages appliqués avec succès !');
							this.showModal = false;
							this.$emit('refresh');
						}
					})
					.catch(err => {
						this.$toast.error(err.response.data['hydra:description']);
					});
			},
		},
	};
</script>
